<template>
  <div
    class="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8"
  >
    <div class="max-w-md w-full">
      <div>
        <router-link to="/">
          <img
            class="mx-auto h-12 w-auto"
            src="/logo.png"
            alt="ScaffoldHub"
          />
        </router-link>

        <h2
          class="mt-6 text-center text-3xl leading-9 font-extrabold text-gray-900"
        >
          Forgot your password?
        </h2>
      </div>
      <form
        class="mt-8"
        @submit.prevent="sendPasswordResetEmail(email)"
      >
        <div class="rounded-md shadow-sm">
          <div>
            <input
              aria-label="Email address"
              name="email"
              type="email"
              required
              class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
              placeholder="Email address"
              v-model="email"
            />
          </div>
        </div>

        <div class="mt-6">
          <el-button
            class="w-full"
            type="primary"
            :disabled="loading"
            native-type="submit"
          >
            Send me the instructions
          </el-button>

          <div class="mt-5 w-full text-center">
            <router-link
              class="text-sm font-normal text-blue-600 hover:text-blue-500 focus:outline-none focus:underline transition ease-in-out duration-150"
              to="/auth/sign-in"
            >
              Cancel
            </router-link>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'app-auth-forgot-password',

  data() {
    return {
      email: null,
    };
  },

  async created() {
    const authenticated = await this.$store.getters[
      'auth/authenticatedAsync'
    ]();

    if (authenticated) {
      this.$router.push('/');
      return;
    }
  },

  computed: {
    ...mapGetters({
      loading: 'auth/loading',
    }),
  },

  methods: {
    ...mapActions({
      sendPasswordResetEmail: 'auth/sendPasswordResetEmail',
    }),
  },
};
</script>

<style></style>
